<template>
  <div class="blockuser" v-if="seen">
    <div class="cant_create">
      <div>
        <span @click="closebox" class="close-box">
          <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
            <path
              fill="#000000"
              d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
            />
          </svg>
        </span>
      </div>
      <div>
        <svg style="width: 54px; height: 54px" viewBox="0 0 24 24">
          <path
            fill="#FC6D6C"
            d="M12,20A7,7 0 0,1 5,13C5,11.72 5.35,10.5 5.95,9.5L15.5,19.04C14.5,19.65 13.28,20 12,20M3,4L1.75,5.27L4.5,8.03C3.55,9.45 3,11.16 3,13A9,9 0 0,0 12,22C13.84,22 15.55,21.45 17,20.5L19.5,23L20.75,21.73L13.04,14L3,4M11,9.44L13,11.44V8H11M15,1H9V3H15M19.04,4.55L17.62,5.97C16.07,4.74 14.12,4 12,4C10.17,4 8.47,4.55 7.05,5.5L8.5,6.94C9.53,6.35 10.73,6 12,6A7,7 0 0,1 19,13C19,14.27 18.65,15.47 18.06,16.5L19.5,17.94C20.45,16.53 21,14.83 21,13C21,10.88 20.26,8.93 19.03,7.39L20.45,5.97L19.04,4.55Z"
          />
        </svg>
      </div>
      <div class="text">
        You can create a file in <strong>{{ name }}</strong
        >.<br />
        Navigate to other folders to create a file
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      seen: false,
      loader: true,
      name: "",
    };
  },
  methods: {
    load(name) {
      this.name = name;
      this.seen = true;
    },
    closebox() {
      this.seen = false;
    },
  },
};
</script>
